let corpId, agentId, hostServer, loginUrl,miniProgramAppId, miniProgramCover, customerLoadingIcon, miniProgramTitle, formTitle, homeTopBg;
if (window.location.host === "qywx.jinzhimc.cn") {
    // 金致
    corpId = "ww923c74aac6f4eb2f";
    agentId = "1000005";
    hostServer = "https://server.jinzhimc.cn";
    loginUrl = "https://qywx.jinzhimc.cn/login";
    miniProgramAppId = "wx82a4ca081264e38f";
    // miniProgramCover= "https://jinzhi-scrm.oss-cn-chengdu.aliyuncs.com/common/jinzhi_scrm_home.png";// 小程序的封面图，用于发送营销物料给客户时，未设置图片，使用默认
    miniProgramCover= "https://jinzhi-scrm.oss-cn-chengdu.aliyuncs.com/common/jinzhi_home2.jpg";// 小程序的封面图，用于发送营销物料给客户时，未设置图片，使用默认
    miniProgramTitle="金致尚品门窗·公司简介";
    customerLoadingIcon= "https://jinzhi-scrm.oss-cn-chengdu.aliyuncs.com/common/loading_big.gif";// 客户页面，加载图标显示
    formTitle="https://jinzhi-scrm.oss-cn-chengdu.aliyuncs.com/company/form_link_pic.jpg"; // 调查表单填写页面，标题图片
    homeTopBg="./static/theme/jinzhi/home_banner.png"; // 首页，显示在抬头的图片背景
} else if (window.location.host === "qywx.xcwsmc.com") {
    // 欣成
    corpId = "ww6457a8dce17b3685";
    agentId = "1000002";
    hostServer = "https://server.xcwsmc.com";
    loginUrl = "https://qywx.xcwsmc.com/login";
    miniProgramAppId = "wx2e4af03cffe1cd1f";
    // miniProgramCover= "https://xinchengwangsi-scrm.oss-cn-chengdu.aliyuncs.com/common/log_home.jpg";
    miniProgramCover= "https://xinchengwangsi-scrm.oss-cn-chengdu.aliyuncs.com/common/xcws_home2.jpg";
    miniProgramTitle="欣成旺斯门窗·公司简介";
    customerLoadingIcon= "https://xinchengwangsi-scrm.oss-cn-chengdu.aliyuncs.com/common/loading_big.gif";// 客户页面，加载图标显示
    formTitle="https://jinzhi-scrm.oss-cn-chengdu.aliyuncs.com/company/form_link_pic.jpg";
    homeTopBg="./static/theme/xcws/home_banner.jpg";
} else if (window.location.host === "qywx.heyingcgj.com") {
    // 合赢
    corpId = "ww93cd67898324f56b";
    agentId = "1000004";
    hostServer = "https://server.heyingcgj.com";
    loginUrl = "https://qywx.heyingcgj.com/login";
    miniProgramAppId = "wx1d9bf15699abf211";
    miniProgramCover= "https://heyingcgj-scrm.oss-cn-chengdu.aliyuncs.com/mini/qywx_bg.jpg";
    miniProgramTitle="合赢家甄选·公司简介";
    customerLoadingIcon= "https://heyingcgj-scrm.oss-cn-chengdu.aliyuncs.com/mini/logo.png";// 客户页面，加载图标显示
    formTitle="https://jinzhi-scrm.oss-cn-chengdu.aliyuncs.com/company/form_link_pic.jpg";
    homeTopBg="https://heyingcgj-scrm.oss-cn-chengdu.aliyuncs.com/mini/qywx_bg.jpg";
} else if (window.location.host === "qywx.fancemc.com") {
    // 范思泽
    corpId = "ww8ebbec7d2e4ca3cc";
    agentId = "1000002";
    hostServer = "https://server.fancemc.com";
    loginUrl = "https://qywx.fancemc.com/login";
    miniProgramAppId = "wx7a2dbfc24fff4ba7";
    miniProgramCover= "https://jinzhi-scrm.oss-cn-chengdu.aliyuncs.com/fansize/miniprogram-1.jpg";
    miniProgramTitle="范思泽·公司简介";
    customerLoadingIcon= "https://jinzhi-scrm.oss-cn-chengdu.aliyuncs.com/fansize/logo2.jpg";// 客户页面，加载图标显示
    formTitle="https://jinzhi-scrm.oss-cn-chengdu.aliyuncs.com/fansize/form.jpg";
    homeTopBg="https://heyingcgj-scrm.oss-cn-chengdu.aliyuncs.com/fansize/qywx_title.jpg";
} else {
    // 欣成
    // corpId = "ww6457a8dce17b3685";
    // agentId = "1000002";
    // hostServer = "https://server.xcwsmc.com";
    // loginUrl = "https://qywx.xcwsmc.com/login";
    // miniProgramAppId = "wx2e4af03cffe1cd1f";
    // // miniProgramCover= "https://xinchengwangsi-scrm.oss-cn-chengdu.aliyuncs.com/common/log_home.jpg";
    // miniProgramCover= "https://xinchengwangsi-scrm.oss-cn-chengdu.aliyuncs.com/common/xcws_home2.jpg";
    // miniProgramTitle="欣成旺斯门窗·公司简介";
    // customerLoadingIcon= "https://xinchengwangsi-scrm.oss-cn-chengdu.aliyuncs.com/common/loading_big.gif";// 客户页面，加载图标显示
    // formTitle="https://jinzhi-scrm.oss-cn-chengdu.aliyuncs.com/company/form_link_pic.jpg";

    corpId = "ww93cd67898324f56b";
    agentId = "1000004";
    hostServer = "https://server.heyingcgj.com";
    loginUrl = "https://qywx.heyingcgj.com/login";
    miniProgramAppId = "wx2e4af03cffe1cd1f";
    miniProgramCover= "https://heyingcgj-scrm.oss-cn-chengdu.aliyuncs.com/mini/qywx_bg.jpg";
    miniProgramTitle="合赢家甄选·公司简介";
    customerLoadingIcon= "https://heyingcgj-scrm.oss-cn-chengdu.aliyuncs.com/mini/logo.png";// 客户页面，加载图标显示
    formTitle="https://jinzhi-scrm.oss-cn-chengdu.aliyuncs.com/company/form_link_pic.jpg";
    homeTopBg="https://heyingcgj-scrm.oss-cn-chengdu.aliyuncs.com/mini/qywx_bg.jpg";
}

export default {
    corpId,
    agentId,
    hostServer,
    loginUrl,
    miniProgramAppId,
    miniProgramCover,
    customerLoadingIcon,
    miniProgramTitle,
    formTitle,
    homeTopBg
}


// WEBPACK FOOTER //
// ./src/config/systemConfig.js